// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// DeleteSecondaryProgramCourseHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ResultDTO from '../models/ResultDTO';

interface Request {
    secondaryProgramCourseId: string | null;
    academicYearId: number;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            secondaryProgramCourseId: '00000000-0000-0000-0000-000000000000',
            academicYearId: 0,
        },
        initValues);
    },
    secondaryProgramCourseId: 'secondaryProgramCourseId',
    academicYearId: 'academicYearId',
}

interface Result extends ResultDTO {
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
        },
        initValues);
    },
}

export { Request, Result };